import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Button from '@mui/material/Button';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import { connect } from 'react-redux';
import uyoMessages from '../giftCardDetailsPage_v2/messages/uyoMessages';
import { getLoaderStatus } from '../loader/loaderSelector';
import SkeletonLoader from '../loader/SkeletonLoader';



const UYOButton = ({
    intl,
    onClick,
    showLabel = true,
    customLabel = null,
    isLoading
}) => {
    const buttonText = customLabel || intl.formatMessage(uyoMessages.uyoButtonText);

    return (
        <SkeletonLoader
            isLoading={isLoading}
            skeletonProps={{
                animation: 'wave',
                variant: 'rectangular',
                className: 'skeletonclass',
                width: '100%',
                height: 50
            }}
        >
            <div className='uyo-button'>
                <Button
                    className='uyo-button-text uyo-button-text-color text-button'
                    variant="text"
                    onClick={onClick}
                >
                    <AddPhotoAlternateOutlinedIcon className='uyo-button-text-color' />
                    {showLabel && buttonText}
                </Button>
            </div>
        </SkeletonLoader>
    );
};

UYOButton.propTypes = {
    intl: intlShape.isRequired,
    onClick: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    customLabel: PropTypes.string,
    isLoading: PropTypes.bool.isRequired
};

UYOButton.defaultProps = {
    showLabel: true,
    customLabel: null
};
const mapStateToProps = state => ({
    isLoading: getLoaderStatus(state)
});

export default connect(mapStateToProps, null)(injectIntl(UYOButton));
